var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"w-100",attrs:{"src":require("@/assets/images/logo/Logo.svg"),"alt":"Logo"}})])}]

export { render, staticRenderFns }